<template>
    <div class="content">
        <div class="content_container_row">
            <div class="content_row">
                <select class="sub_group_select" v-model="search_type" @change="search()">
                    <option :value="null" disabled>Тип пошуку</option>
                    <option :value="2">За артикулом</option>
                    <option :value="3">За назвою</option>
                </select>
                <div class="search_input_container" :class="{zindex0: isShowCatalog || docmodal || modal_confirm || modal_confirm_tab || !searchResult }">
                    <div class="search_input_block">
                        <input class="catalog_search_input" @focus="() => {overlay = true; searchResult = true; isShowCatalog = false; }" v-on:keyup="search()" v-model="searchval" placeholder="Пошук" />
                        
                        <svg v-if="!showClearInput" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                        </svg>

                        <svg id="close_modal" v-if="showClearInput" @click="clearSearch()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="search_results" v-if="searchResult">
                        <div class="products" v-if="searchProducts.length">
                            <p class="cat_title" v-for="(product, key) in searchProducts" :key="key" @click.stop="getProductFiles(product.id)">{{ product.name }}</p>
                        </div>
                        <p class="cat_title" v-if="!searchProducts.length">Немає результатів</p>
                    </div>
                </div>
            </div>

            <div class="main_content">
                <div class="result_content">
                    <template v-if="path">
                        <div class="result_content_row">
                            <div class="top_container">
                                <p class="result_content_title">{{ path }}</p>
                            </div>
                            <a href="javascript:void(0)" v-tooltip.bottom="'Закрити'">
                                <svg @click="clearResult()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </div>

                        <template v-if="selectedProductData">
                            <div class="tab_content_item_form_input">
                                <span class="tab_content_item_form_input_label">Найменування</span>
                                <div class="input_row">
                                    <input class="form_input" disabled type="text" v-model="selectedProductData.name">
                                    <Tag severity="danger" value="Акція" v-if="selectedProductData.is_promo"></Tag>
                                    <Tag severity="danger" value="Новинка" v-if="selectedProductData.is_new"></Tag>
                                    <Tag severity="danger" value="Хіт" v-if="selectedProductData.is_hit"></Tag>
                                    <Tag severity="success" value="B2C" v-if="selectedProductData.is_b2c"></Tag>
                                </div>
                            </div>

                            <div class="row_inputs">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">ID</span>
                                    <div class="input_row">
                                        <input class="form_input" disabled type="text" v-model="selectedProductData.remote_id">
                                    </div>
                                </div>
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">Артикул</span>
                                    <div class="input_row">
                                        <input class="form_input" disabled type="text" v-model="selectedProductData.article">
                                    </div>
                                </div>
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">Статус</span>
                                    <div class="input_row">
                                        <input class="form_input" disabled type="text" :value="selectedProductData.status === 'a' ? 'Активний' : 'Вимкнено'">
                                    </div>
                                </div>
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">URL до картки товару</span>
                                    <div class="input_row" @click="copyProductUrl()" v-tooltip.bottom="'Копіювати посилання'">
                                        <input class="form_input" v-on:focus="$event.target.select()" ref="clone" readonly type="text" :value="product_url">
                                        <a href="javascript:void(0)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M6 11.9999C5.63333 11.9999 5.31944 11.8694 5.05833 11.6083C4.79722 11.3471 4.66667 11.0333 4.66667 10.6666V2.66659C4.66667 2.29992 4.79722 1.98603 5.05833 1.72492C5.31944 1.46381 5.63333 1.33325 6 1.33325H12C12.3667 1.33325 12.6806 1.46381 12.9417 1.72492C13.2028 1.98603 13.3333 2.29992 13.3333 2.66659V10.6666C13.3333 11.0333 13.2028 11.3471 12.9417 11.6083C12.6806 11.8694 12.3667 11.9999 12 11.9999H6ZM6 10.6666H12V2.66659H6V10.6666ZM3.33333 14.6666C2.96667 14.6666 2.65278 14.536 2.39167 14.2749C2.13056 14.0138 2 13.6999 2 13.3333V3.99992H3.33333V13.3333H10.6667V14.6666H3.33333Z" fill="#356EEF"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </template>

                        <div class="tabs main_tabs">
                            <div class="tab" :class="{active: selectedTab === 1}" @click="selectedTab=1">Документи</div>
                            <div class="tab" :class="{active: selectedTab === 2}" @click="selectedTab=2">Опис</div>
                            <!-- <div class="tab" :class="{active: selectedTab === 10}" @click="selectedTab=10">360 view</div> -->
                            <div class="tab" :class="{active: selectedTab === 3}" @click="selectedTab=3">Характеристики</div>
                            <div class="tab" :class="{active: selectedTab === 4}" @click="selectedTab=4">Аксесуари</div>
                            <div class="tab" :class="{active: selectedTab === 5}" @click="selectedTab=5">Аналог</div>
                            <div class="tab" :class="{active: selectedTab === 6}" @click="selectedTab=6">З цим товаром купують</div>
                            <div class="tab" :class="{active: selectedTab === 7}" @click="selectedTab=7">Аналоги ринку</div>
                            <div class="tab" :class="{active: selectedTab === 8}" @click="selectedTab=8">Категорія товару</div>
                            <div class="tab" :class="{active: selectedTab === 9}" @click="selectedTab=9">Рішення</div>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===1">
                            <div class="top_panel">
                                <div class="tabs">
                                    <div class="content_tab content_tab-item" v-for="(tab, i) in items" :key="`tab_${i}`" :class="{'active': activeTab === i}" @click.prevent="selectTab(i)">
                                        <span v-if="tab.files[0] || tab.title === 'Фото'">{{ tab.title }}</span>
                                        <span v-else>{{ tab.title }}</span>
                                        <svg v-if="is_add_new_type" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" v-on:click.prevent="deleteTab(i)">
                                            <path d="M1.26634 9.66658L0.333008 8.73325L4.06634 4.99992L0.333008 1.26659L1.26634 0.333252L4.99967 4.06659L8.73301 0.333252L9.66634 1.26659L5.93301 4.99992L9.66634 8.73325L8.73301 9.66658L4.99967 5.93325L1.26634 9.66658Z" fill="#B70D09"/>
                                        </svg>
                                        <svg v-if="is_add_new_type && tab.title !== 'Фото'" xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 15 16" fill="none" v-on:click.prevent="editTab(i)">
                                            <path d="M14.5331 1.94003C14.6207 2.03375 14.6699 2.16069 14.6699 2.29303C14.6699 2.42536 14.6207 2.5523 14.5331 2.64603L13.5553 3.69003L11.6803 1.69003L12.6581 0.646027C12.746 0.552292 12.8652 0.499634 12.9895 0.499634C13.1138 0.499634 13.233 0.552292 13.3209 0.646027L14.5331 1.93903V1.94003ZM12.8925 4.39603L11.0175 2.39603L4.63031 9.21003C4.57871 9.26505 4.53987 9.33217 4.51687 9.40603L3.76219 11.82C3.7485 11.864 3.74656 11.9112 3.75658 11.9564C3.76659 12.0015 3.78818 12.0427 3.81891 12.0755C3.84965 12.1083 3.88833 12.1313 3.93063 12.142C3.97293 12.1527 4.01718 12.1506 4.05844 12.136L6.32156 11.331C6.39072 11.3068 6.45363 11.2657 6.50531 11.211L12.8925 4.39603Z" fill="#356EEF"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.9375 13.5C0.9375 13.8979 1.08566 14.2794 1.34938 14.5607C1.6131 14.842 1.97079 15 2.34375 15H12.6562C13.0292 15 13.3869 14.842 13.6506 14.5607C13.9143 14.2794 14.0625 13.8979 14.0625 13.5V7.50003C14.0625 7.36742 14.0131 7.24024 13.9252 7.14647C13.8373 7.05271 13.7181 7.00003 13.5938 7.00003C13.4694 7.00003 13.3502 7.05271 13.2623 7.14647C13.1744 7.24024 13.125 7.36742 13.125 7.50003V13.5C13.125 13.6326 13.0756 13.7598 12.9877 13.8536C12.8998 13.9473 12.7806 14 12.6562 14H2.34375C2.21943 14 2.1002 13.9473 2.01229 13.8536C1.92439 13.7598 1.875 13.6326 1.875 13.5V2.50003C1.875 2.36742 1.92439 2.24024 2.01229 2.14647C2.1002 2.05271 2.21943 2.00003 2.34375 2.00003H8.4375C8.56182 2.00003 8.68105 1.94735 8.76896 1.85358C8.85686 1.75981 8.90625 1.63264 8.90625 1.50003C8.90625 1.36742 8.85686 1.24024 8.76896 1.14647C8.68105 1.05271 8.56182 1.00003 8.4375 1.00003H2.34375C1.97079 1.00003 1.6131 1.15806 1.34938 1.43937C1.08566 1.72067 0.9375 2.1022 0.9375 2.50003V13.5Z" fill="#356EEF"/>
                                        </svg>
                                    </div>
                                    <div class="content_tab disabled" @click.prevent="addTab()" v-if="is_add_new_type">
                                        <span>+ Додати категорію</span>
                                    </div>
                                </div>
                                <div v-tooltip.bottom="'Ви можете додати до 10 елементів'" tabindex="1">
                                    <svg id="tooltip1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_7547_1269)">
                                            <path d="M7.33337 4.66665H8.66671V5.99998H7.33337V4.66665ZM7.33337 7.33331H8.66671V11.3333H7.33337V7.33331ZM8.00004 1.33331C4.32004 1.33331 1.33337 4.31998 1.33337 7.99998C1.33337 11.68 4.32004 14.6666 8.00004 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00004 1.33331ZM8.00004 13.3333C5.06004 13.3333 2.66671 10.94 2.66671 7.99998C2.66671 5.05998 5.06004 2.66665 8.00004 2.66665C10.94 2.66665 13.3334 5.05998 13.3334 7.99998C13.3334 10.94 10.94 13.3333 8.00004 13.3333Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_7547_1269">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>

                            <div class="files_table_container">
                                <table class="files_table" v-if="items[activeTab]" :key="activeTab">
                                    <tr>
                                        <th><input type="checkbox" :checked="selectAllCheckbox" :indeterminate="indeterminate" @click="selectAllFiles()"></th>
                                        <th>Файл</th>
                                        <th>Найменування</th>
                                        <th>Розмір файлу</th>
                                        <th v-if="items[activeTab] && items[activeTab].files[0] && (items[activeTab].files[0].type === 'photo' || items[activeTab].files[0].type === 'video')">Основне фото</th>
                                        <th>Додано</th>
                                        <th>Ким змінено</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(file, key) in items[activeTab].files" :key="key">
                                        <td class="text_center"><input type="checkbox" class="input_checkbox" @change="checkSelected()" :value="file.id" v-model="selectedFiles"></td>
                                        <td>
                                            <img height="46" :src="file.url" v-if="file.type === 'photo'">
                                            <a :href="file.url" target="_blank" v-else>
                                                <svg width="30" height="50" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-56da0eae="">
                                                    <path d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0H2ZM9 7V1.5L14.5 7H9Z" fill="#356EEF" data-v-56da0eae=""></path>
                                                </svg>
                                            </a>
                                        </td>
                                        <td>{{ file.name }} {{ file.count ? '(' + file.count + ')' : '' }}</td>
                                        <td>{{ formatBytes(file.size) }}</td>
                                        <td v-if="file.type === 'photo'"><input type="radio" :value="true" :checked="key === 0" v-model="file.is_main" @change="makeFileMain(file)"></td>
                                        <td v-if="file.type === 'video'"></td>
                                        <td>{{ file.created_at }}</td>
                                        <td>{{ file.author }}</td>
                                        <td>
                                            <a href="javascript:void(0)" v-on:click="deleteFile(file.id)" v-tooltip.bottom="'Видалити'">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16" fill="none">
                                                    <path d="M4.26683 12.6663L3.3335 11.733L7.06683 7.99967L3.3335 4.26634L4.26683 3.33301L8.00016 7.06634L11.7335 3.33301L12.6668 4.26634L8.9335 7.99967L12.6668 11.733L11.7335 12.6663L8.00016 8.93301L4.26683 12.6663Z" fill="#B70D09"/>
                                                </svg>
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <p class="file_count">Кількість файлів: {{ items[activeTab] && items[activeTab].files ? items[activeTab].files.length : 0 }}</p>

                            <div class="bottom_btns" v-if="items[activeTab]">
                                <a href="javascript:void(0)" class="add_file_btn" v-on:click="docmodal = true">Завантажити документ</a>
                                <a href="javascript:void(0)" class="delete_file_btn" v-if="selectedFiles.length" v-on:click="deleteFiles()">Видалити</a>
                            </div>
                            <div class="bottom_btns" v-else>
                                <a href="javascript:void(0)" disabled class="disabled add_file_btn">Завантажити документ</a>
                            </div>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===2">
                            <div class="files_table_container">
                                <a href="javascript:void(0)" v-if="!isEditorPreviewHtml" @click="isEditorPreviewHtml = true">Перегляд HTML</a>
                                <a href="javascript:void(0)" v-else @click="isEditorPreviewHtml = false">Повернутись до редактору</a>
                                <Editor v-if="!isEditorPreviewHtml" v-model="selectedProductData.description" editorStyle="height: 320px" class="product_description_text">
                                    <template v-slot:toolbar>
                                        <span class="ql-formats">
                                            <select class="ql-font"></select>
                                            <select class="ql-size"></select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-bold"></button>
                                            <button class="ql-italic"></button>
                                            <button class="ql-underline"></button>
                                            <button class="ql-strike"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <select class="ql-color"></select>
                                            <select class="ql-background"></select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-script" value="sub"></button>
                                            <button class="ql-script" value="super"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-header" value="1"></button>
                                            <button class="ql-header" value="2"></button>
                                            <button class="ql-blockquote"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list" value="ordered"></button>
                                            <button class="ql-list" value="bullet"></button>
                                            <button class="ql-indent" value="-1"></button>
                                            <button class="ql-indent" value="+1"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-direction" value="rtl"></button>
                                            <select class="ql-align"></select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-link"></button>
                                            <button class="ql-image"></button>
                                            <button class="ql-video"></button>
                                            <button class="ql-formula"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-clean"></button>
                                        </span>
                                    </template>
                                </Editor>
                                <Textarea v-else v-model="selectedProductData.description" rows="20" class="editor_textarea" />
                            </div>

                            <div class="bottom_btns">
                                <a href="javascript:void(0)" class="add_file_btn" @click="saveProduct()">Зберегти</a>
                            </div>
                        </div>
                        <!-- <div class="caontent_container" v-if="selectedTab===10">
                            <div class="files_table_container">
                                <input class="form_input" :value="selectedProductData.media?.virtual_tour">
                            </div>
                        </div> -->
                        <div class="caontent_container" v-if="selectedTab===3">
                            <div class="files_table_container">
                            <DataTable :value="productsCharacteristics" :reorderableColumns="true" v-model:selection="selectedCharacteristics" @rowReorder="onRowReorder" :rowClass="rowClass" tableStyle="min-width: 50rem" class="customTable productSkuTable">
                                <Column rowReorder headerStyle="width: 3rem" :reorderableColumn="false">
                                    <template #rowreordericon>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.00004 13.6673L4.16671 10.834L5.11671 9.88398L6.33337 11.1007V7.66732H2.91671L4.13337 8.86732L3.16671 9.83398L0.333374 7.00065L3.15004 4.18398L4.10004 5.13398L2.90004 6.33398H6.33337V2.90065L5.11671 4.11732L4.16671 3.16732L7.00004 0.333984L9.83337 3.16732L8.88337 4.11732L7.66671 2.90065V6.33398H11.0834L9.86671 5.13398L10.8334 4.16732L13.6667 7.00065L10.8334 9.83398L9.88337 8.88398L11.1 7.66732H7.66671V11.084L8.86671 9.86732L9.83337 10.834L7.00004 13.6673Z" fill="#356EEF"/>
                                        </svg>
                                    </template>
                                </Column>
                                <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                                <Column field="category" header="Категорія">
                                    <template #body="slotProps">
                                        {{
                                            slotProps.data.name
                                        }}
                                    </template>
                                </Column>
                                <Column field="value" header="Значення">
                                    <template #body="slotProps">
                                        <InputText class="price_input" v-model="slotProps.data.value" />
                                    </template>
                                </Column>
                                <Column field="unit" header="Од. виміру">
                                    <template #body="slotProps">
                                        <InputText class="price_input" disabled v-model="slotProps.data.unit" />
                                    </template>
                                </Column>
                                <Column field="" header="">
                                    <template #body="slotProps">
                                        <a href="#" @click.prevent="() => {selectedCharacteristics=[]; selectedCharacteristics.push(slotProps.data); deleteCharacteristics()}">
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                                            </svg>
                                        </a>
                                    </template>
                                </Column>
                            </DataTable>
                            </div>

                            <div class="bottom_btns">
                                <a href="javascript:void(0)" class="add_file_btn" @click="saveProductCharacteristics()">Зберегти</a>
                                <a href="javascript:void(0)" class="add_file_btn main" @click="isAddCharacteristics=true">Додати нову</a>
                                <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedCharacteristics.length" @click="deleteCharacteristics()">Видалити</a>
                                <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
                            </div>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===4">
                            <CatalogProductTable
                                :key="selectedTab"
                                :selected-product-id="selectedProductData.remote_id"
                                :items="accessories"
                                :types="acessoryTypes"
                                :type="'accessories'"
                                :route-type="'accessory'"
                                :zindex="isShowCatalog || docmodal || modal_confirm || modal_confirm_tab || !searchResult"
                                @saveProduct="saveProduct()"
                                @accessories="(data) => accessories = data"
                            ></CatalogProductTable>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===5">
                            <CatalogProductTable
                                :key="selectedTab"
                                :selected-product-id="selectedProductData.remote_id"
                                :items="analogs"
                                :type="'analogs'"
                                :route-type="'analog'"
                                :zindex="isShowCatalog || docmodal || modal_confirm || modal_confirm_tab || !searchResult"
                                @saveProduct="saveProduct()"
                                @analogs="(data) => analogs = data"
                            ></CatalogProductTable>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===6">
                            <CatalogProductTable
                                :key="selectedTab"
                                :selected-product-id="selectedProductData.remote_id"
                                :items="buy_with_products"
                                :type="'buy_with_products'"
                                :route-type="'buy_with_product'"
                                :zindex="isShowCatalog || docmodal || modal_confirm || modal_confirm_tab || !searchResult"
                                @saveProduct="saveProduct()"
                                @buy_with_products="(data) => buy_with_products = data"
                            ></CatalogProductTable>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===7">
                            <table class="min-w-full bg-white border rounded" style="margin-top: 20px;">
                                <thead>
                                    <tr>
                                        <th class="px-4 py-2 border text-left">Артикул</th>
                                        <th class="px-4 py-2 border text-left">Назва</th>
                                        <th class="px-4 py-2 border text-left">Характеристики</th>
                                        <th class="px-4 py-2 border text-left"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in selectedProductData.service_analogs" :key="item.article" class="hover:bg-gray-100">
                                        <td class="px-4 py-2 border">{{ item.article }}</td>
                                        <td class="px-4 py-2 border">{{ item.name }}</td>
                                        <td class="px-4 py-2 border">{{ item.characteristics }}</td>
                                        <td class="px-4 py-2 border">
                                            <a href="#" @click.prevent="deleteCatalogProductAnalog(item.id)">
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                                                </svg>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===8">
                            <div class="confirm_buttons">
                                <Dropdown v-model="selectedProductData.type_id" filter :options="productTypes" optionLabel="name" optionValue="code" placeholder="Оберіть тип" style="width: 100%;" />
                                <a href="#" class="confirm_button_cancel" style="max-width: 150px;height: auto;padding: initial;justify-content: center;" @click.prevent="saveProduct()">Зберегти</a>
                            </div>
                        </div>
                        <div class="caontent_container" v-if="selectedTab===9">
                            <table class="min-w-full bg-white border rounded" style="margin-top: 20px;">
                                <thead>
                                    <tr>
                                        <th class="px-4 py-2 border text-left">Найменування рішення</th>
                                        <th class="px-4 py-2 border text-left">Типи клієнтів</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(decision, key) in decisions" :key="key" class="hover:bg-gray-100">
                                        <td class="px-4 py-2 border">{{ decision.name }}</td>
                                        <td class="px-4 py-2 border">
                                            <div class="flex_list">
                                                <p style="margin: 0px;" v-for="(client_type, key) in decision.client_types" :key="key">{{ client_type.name }}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </template>
                    <template v-else>
                        <p class="text_secondary">Для завантаження/редагування документів оберіть SKU, скориставшись Пошуком, <br> або категорію для групового додавання, скориставшись деревом каталогу</p>
                    </template>
                </div>
            </div>

        </div>

        <div class="overlay" v-if="docmodal || modal_confirm || modal_confirm_tab || searchResult || accessorySearchResult || add_new_tab_modal || edit_tab_modal" v-on:click="() => { docmodal = false; modal_confirm=false; modal_confirm_tab=false; accessorySearchResult=false; searchResult=false; edit_tab_modal=false; }"></div>
        <div class="modal docmodal" v-if="docmodal">
            <div class="doc_modal_form_container">
                <div class="modal_header">
                    <p class="modal_header_title">Прикріпити документ</p>
                    <svg id="close_docmodal" v-on:click="docmodal = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="doc_modal_form_content" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.35 6.04C18.67 2.59 15.64 0 12 0C9.11 0 6.6 1.64 5.35 4.04C2.34 4.36 0 6.91 0 10C0 13.31 2.69 16 6 16H19C21.76 16 24 13.76 24 11C24 8.36 21.95 6.22 19.35 6.04ZM14 9V13H10V9H7L12 4L17 9H14Z" fill="#356EEF"/>
                    </svg>


                    <div class="file_modal_container">
                        <input type="file" 
                            accept="application/pdf,image/x-dwg,application/acad,image/vnd.dwg,image/x-dxf,drawing/x-dwf,application/octet-stream,image/jpeg,image/png,application/vnd.rar,application/x-rar-compressed,application/zip,application/x-zip-compressed,multipart/x-zip,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.dwg,.mp4"
                            @change="onChange"
                            ref="file"
                            style="display: none;"
                            multiple
                        >
                        <a class="modal_btn_link" @click="$refs.file.click()"><p>Натисніть щоб прикріпити файли до заявки</p></a>

                        <span class="text_secondary">Формат: pdf, png, jpeg, dwg, fra, ini, zip, txt, a3d, m3d, stp, step, rar, doc, docx, xls, xlsx
                            Загальний розмір файлу до 50 Мб. 
                            Не більше 20 файлів </span>
                        
                        <!-- <p class="modal_text">або</p>
                        <p class="modal_text">Додайте посилання на гугл диск для прямого посилання на файл</p>
                        <div class="modal_input_container">
                            <svg class="link_ico" width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.1 12H6C4.34 12 2.925 11.415 1.755 10.245C0.585 9.075 0 7.66 0 6C0 4.34 0.585 2.925 1.755 1.755C2.925 0.585 4.34 0 6 0H11.1V1.8H6C4.84 1.8 3.85 2.21 3.03 3.03C2.21 3.85 1.8 4.84 1.8 6C1.8 7.16 2.21 8.15 3.03 8.97C3.85 9.79 4.84 10.2 6 10.2H11.1V12ZM7.35 6.9V5.1H16.65V6.9H7.35ZM12.9 12V10.2H18C19.16 10.2 20.15 9.79 20.97 8.97C21.79 8.15 22.2 7.16 22.2 6C22.2 4.84 21.79 3.85 20.97 3.03C20.15 2.21 19.16 1.8 18 1.8H12.9V0H18C19.66 0 21.075 0.585 22.245 1.755C23.415 2.925 24 4.34 24 6C24 7.66 23.415 9.075 22.245 10.245C21.075 11.415 19.66 12 18 12H12.9Z" fill="#356EEF"/>
                            </svg>

                            <input type="text" class="google_drive_link noselect" :class="{ 'border-danger': googleDriveLinkError }" v-on:input="addDriveLink" v-model="google_drive_link">

                            <svg class="close_ico" v-if="google_drive_link" v-on:click="() => {google_drive_link = null; googleDriveLinkError = false;}" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#6C757D"/>
                            </svg>
                        </div> -->
                    </div>
                </div>

                <div class="added_files_header" v-if="filelist.length">
                    <span class="added_files">Додані файли</span>
                </div>
                <ul class="filelist" v-if="filelist.length">
                    <li class="filelist_item" v-for="(file, i) in filelist" :key="`file_${i}`">
                        <div class="file_item">
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                            </svg>

                            <div class="file_item_container">
                                <span class="file_name">{{ file.name }} ({{ formatBytes(file.size) }})</span>
                                <a @click="remove(filelist.indexOf(file))" class="remove_file_btn" title="Remove file">
                                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 16C1.5 17.1 2.4 18 3.5 18H11.5C12.6 18 13.5 17.1 13.5 16V4H1.5V16ZM14.5 1H11L10 0H5L4 1H0.5V3H14.5V1Z" fill="#4C5567"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>

                <div class="files_btns_row" v-if="filelist.length || (google_drive_link && !googleDriveLinkError)">
                    <a href="javascript:void(0)" class="confirm_btn" v-if="uploading">Зачекайте..</a>
                    <a href="javascript:void(0)" class="confirm_btn" v-else @click="upload()">Завантажити</a>
                    <a href="javascript:void(0)" v-on:click="docmodal = false" class="cancel_btn">Відмінити</a>
                </div>
            </div>
        </div>
        <div class="modal description_modal" v-if="modal_confirm">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">{{ confirm_title }}</p>
                    <svg id="close_docmodal" v-on:click="modal_confirm = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content" v-text="confirm_text"></div>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="confirm()">Видалити</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="modal_confirm = false">Відмінити</a>
                </div>
            </div>
        </div>
        <div class="modal description_modal" v-if="modal_confirm_tab">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">{{ confirm_title }}</p>
                    <svg id="close_docmodal" v-on:click="modal_confirm_tab = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content" v-text="confirm_text"></div>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="confirmTab()">Видалити</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="modal_confirm_tab = false">Відмінити</a>
                </div>
            </div>
        </div>
        <div class="modal description_modal add_new_tab_modal" v-if="add_new_tab_modal">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Додавання категорії</p>
                    <svg id="close_docmodal" v-on:click="()=> {add_new_tab_modal = false; deleteNewTab(activeTab)}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content">Оберіть категорію документів серед існуючих</div>
                <!-- <div class="modal_confirm_content danger">Увага, якщо категорія необхідного вам типу вже існує, то її необхідно обрати, а не створювати нову подібну</div> -->

                <div class="tab_content_item_form_input" v-if="is_add_new_type">
                    <span class="tab_content_item_form_input_label">Існуючі категорії документів</span>
                    <div class="input_row">
                        <select :class="{border_error: newTabTitleRequired}" class="new_tab_select" v-model="newTabTitle">
                            <option :value="null">Обрати</option>
                            <option v-for="(type, key) in getTypes()" :key="key" :value="type">{{ type }}</option>
                        </select>
                    </div>
                </div>
                <br>
                <!-- <div class="tab_content_item_form_input" v-if="is_add_new_category">
                    <span class="tab_content_item_form_input_label">Створити нову</span>
                    <div class="input_row">
                        <input class="new_tab_input" type="text" v-model="items[activeTab].title">
                    </div>
                </div>
                <br> -->
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addNewTab(activeTab)">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="deleteNewTab(activeTab)">Відмінити</a>
                </div>
            </div>
        </div>
        <div class="modal description_modal add_new_tab_modal" v-if="edit_tab_modal">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Редагування категорії</p>
                    <svg id="close_docmodal" v-on:click="edit_tab_modal = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_confirm_content">Оберіть серед існуючих, або створіть нову</div>
                <div class="modal_confirm_content danger">Увага, якщо категорія необхідного вам типу вже існує, то її необхідно обрати, а не створювати нову подібну</div>

                <div class="tab_content_item_form_input" v-if="is_add_new_type">
                    <span class="tab_content_item_form_input_label">Існуючі категорії документів</span>
                    <div class="input_row">
                        <select class="new_tab_select" v-model="items[activeTab].title">
                            <option :value="null">Обрати</option>
                            <option v-for="(type, key) in getTypes()" :key="key" :value="type">{{ type }}</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="tab_content_item_form_input" v-if="is_add_new_category">
                    <span class="tab_content_item_form_input_label">Редагувати назву</span>
                    <div class="input_row">
                        <input class="new_tab_input" type="text" v-model="items[activeTab].title">
                    </div>
                </div>
                <br>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="saveTab(activeTab)">Зберегти</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="edit_tab_modal=false">Відмінити</a>
                </div>
            </div>
        </div>

        <Dialog v-model:visible="isAddCharacteristics" id="characteristics-table" header="Додавання нової характеристики" :style="{ width: '500px' }" modal :contentStyle="{ height: '900px' }">
            <div class="modal_main_content">
                <span>Оберіть серед існуючих категорій.</span>
                <div class="search_result" v-if="selectedCharacteristicsOptions.length">
                    <div class="results_badge" v-for="(selectedCharacteristicsOption, key) in selectedCharacteristicsOptions" :key="key">
                        {{ selectedCharacteristicsOption.value }}
                        <svg @click.stop="clearSelectedCharacteristic(selectedCharacteristicsOption.id)" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                        </svg>
                    </div>
                </div>
                <InputText v-model="searchCharacteristics" @input="searchCharacteristic()" :placeholder="'Пошук'" />
            </div>
            <div class="nested_list">
                <template v-if="!resultCharacteristics.length">
                <div class="select_group_container" v-for="(characteristicItems, key) in characteristics" :key="key">
                    <div class="select_group" @click="openGroup(key)">
                        <p>{{ key }}</p>
                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.99995 0.0500975C6.13328 0.0500975 6.25828 0.070931 6.37495 0.112597C6.49162 0.154264 6.59995 0.225098 6.69995 0.325098L11.3 4.9251C11.4833 5.10843 11.575 5.34176 11.575 5.6251C11.575 5.90843 11.4833 6.14176 11.3 6.3251C11.1166 6.50843 10.8833 6.6001 10.6 6.6001C10.3166 6.6001 10.0833 6.50843 9.89995 6.3251L5.99995 2.4251L2.09995 6.3251C1.91662 6.50843 1.68328 6.6001 1.39995 6.6001C1.11662 6.6001 0.883285 6.50843 0.699951 6.3251C0.516618 6.14176 0.424951 5.90843 0.424951 5.6251C0.424951 5.34176 0.516618 5.10843 0.699951 4.9251L5.29995 0.325098C5.39995 0.225098 5.50828 0.154264 5.62495 0.112597C5.74162 0.070931 5.86662 0.0500975 5.99995 0.0500975Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="selected_group_items" v-if="!openedGroups.includes(key)">
                        <div v-for="(characteristicItem, i) in characteristicItems" :key="i" class="modal_group_item">
                            <label>
                            <input type="checkbox" :value="characteristicItem.id" v-model="selectedModalCharacteristics">
                            <p>{{ characteristicItem.name }}{{ characteristicItem.unit ? ', ' + characteristicItem.unit : '' }}</p>
                            </label>
                        </div>
                    </div>
                </div>
                </template>

                <div class="selected_group_items" v-else>
                    <div v-for="(characteristicItem, i) in resultCharacteristics" :key="i" class="modal_group_item">
                        <label>
                        <input type="checkbox" :value="characteristicItem.id" v-model="selectedModalCharacteristics">
                        <p>{{ characteristicItem.name }}{{ characteristicItem.unit ? ', ' + characteristicItem.unit : '' }}</p>
                        </label>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addCharacteristics()">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isAddCharacteristics=false">Відмінити</a>
                </div>
            </template>
        </Dialog>

        <Toast />
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import axios from "axios";
import { nextTick } from 'vue'
import Tooltip from 'primevue/tooltip';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Dialog from 'primevue/dialog';
import FormHelper from './mixins/form_helper';
import Input from '../Jetstream/Input.vue';
import Toast from 'primevue/toast';
import Tag from 'primevue/tag';
import swal from 'sweetalert2';
import Editor from 'primevue/editor';
import Textarea from 'primevue/textarea';
import Dropdown from 'primevue/dropdown';

import CatalogProductTable from "../Components/CatalogProductTable.vue";

export default {
    directives: {
        Tooltip,
    },
    mixins: [FormHelper],
    layout: AppLayout,
    components: {
        AppLayout,
        DataTable,
        Column,
        Input,
        InputText,
        Dialog,
        Toast,
        swal,
        Editor,
        Tag,
        CatalogProductTable,
        Textarea,
        Dropdown,
    },
    computed: {
        selectedCharacteristicsOptions() {
            let result = [];
            
            if (this.selectedModalCharacteristics && this.selectedModalCharacteristics.length) {
                this.selectedModalCharacteristics.forEach(itemID => {
                    for (const [key, values] of Object.entries(this.characteristics)) {
                        values.forEach((v, index) => {
                            if (itemID === v.id) {
                                let data = {id: v.id, value: v.name}
                                result.push(data)
                            }
                        });
                    }
                });
            }

            return result
        }
    },
    data() {
        return {
            isShowCatalog: false,
            showGroups: [],
            loadingData: false,
            selectedType: null,
            selectedCode: null,
            selectedTitle: null,
            selectedItemTitle: null,
            tree: [],
            submenuTree: [],
            searchval: null,
            showClearInput: false,
            searchResult: false,
            searchProducts: [],

            selectedFiles: [],

            uploading: false,

            activeTab: 0,

            product_url: null,

            oldTitle: null,

            indeterminate: false,

            confirm_title: null,
            confirm_text: null,

            docmodal: false,
            modal_confirm: false,
            modal_confirm_tab: false,
            google_drive_link: null,
            googleDriveLinkError: false,
            filelist: [],

            selectedProductData: null,
            path: '',
            items: [],
            types: [],
            is_add_new_type: false,
            is_add_new_category: false,

            productTypes: [],
            acessoryTypes: [],

            add_new_tab_modal: false,
            edit_tab_modal: false,
            newTabTitle: null,

            selectAllCheckbox: false,

            categoryType: null,
            categoryCode: null,

            search_type: 2,

            accessory_search_type: 2,
            accessory_searchval: null,
            accessoryShowClearInput: false,
            accessorySearchResult: false,
            accessorySearchProducts: [],

            selectedTabFiles: [],

            isEditorPreviewHtml: false,

            selectedTab: 1,
            accessories: [],
            analogs: [],
            buy_with_products: [],
            productsCharacteristics: [],
            selectedCharacteristics: [],
            selectedAccessories: [],
            selectedModalCharacteristics: [],
            isAddCharacteristics: false,
            searchCharacteristics: null,

            characteristics: {},
            resultCharacteristics: [],

            openedGroups: [],

            newTabTitleRequired: false,
            productsCharacteristicsErrors: [],

            decisions: [],
        }
    },
    watch: {
        '$parent.$data.staticMenuInactive': {
            handler: function(val) {
                if (!val) {
                    this.isShowCatalog = false
                }
            },
            deep: true
        },
    },
    mounted() {
        this.getTree();
    },
    methods: {
        getTypes() {
            let itemsArray = []
            this.items.forEach((i, k) => {
                itemsArray.push(i.title);
            });

            let data = []
            this.types.forEach((v, i) => {
                if (!itemsArray.includes(v)) {
                    data.push(v);
                }
            });

            return data
        },
        onRowReorder(event) {
            this.productsCharacteristics = event.value;
        },
        openGroup(key) {
            if (this.openedGroups.includes(key)) {
                let index = this.openedGroups.indexOf(key);
                if (index !== -1) {
                    this.openedGroups.splice(index, 1);
                }
            } else {
                this.openedGroups.push(key)
            }
        },
        selectAllFiles() {
            this.indeterminate = false
            if (this.items[this.activeTab]) {
                if (this.selectedFiles.length && this.selectedFiles.length !== this.items[this.activeTab].files.length) {
                    this.selectedFiles = []
                    this.selectAllCheckbox = false
                } else {
                    this.items[this.activeTab].files.forEach((v, i) => {
                        if (this.selectedFiles.includes(v.id)) {

                            let index = this.selectedFiles.indexOf(v.id);
                            if (index !== -1) {
                                this.selectedFiles.splice(index, 1);
                            }

                        } else {
                            this.selectedFiles.push(v.id);
                        }
                    });
                }
            }
        },
        checkSelected() {
            if (this.items && this.items[this.activeTab]) {
                if (this.selectedFiles.length) {
                    this.selectAllCheckbox = true
                    this.indeterminate = true
                } else {
                    this.indeterminate = false
                    this.selectAllCheckbox = false
                }
            }
        },
        saveProductCharacteristics() {
            // this.productsCharacteristicsErrors = []
            // this.productsCharacteristics.forEach((v, index) => {
            //     if (!v.value) {
            //         this.productsCharacteristicsErrors.push(v.id)
            //     }
            // });

            // if (this.productsCharacteristicsErrors.length) {
            //     this.$toast.add({ severity: 'error', summary: 'Помилка збереження!', detail: 'Ви не заповнили значення', life: 3000 });

            //     return false
            // }

            axios.post(this.route('api.catalog.product.save'), {data: this.selectedProductData, characteristics: this.productsCharacteristics})
                .then((result) => {
                    this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Дані по товару успішно оновлено', life: 3000 });
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
        },
        saveProduct() {
            axios.post(this.route('api.catalog.product.save'), {data: this.selectedProductData, characteristics: this.productsCharacteristics, accessories: this.accessories, buy_with_products: this.buy_with_products})
                .then((result) => {
                    this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Дані по товару успішно оновлено', life: 3000 });
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
        },
        addCharacteristics() {
            this.selectedModalCharacteristics.forEach(itemID => {
                for (const [key, values] of Object.entries(this.characteristics)) {
                    values.forEach((v, index) => {
                        if (itemID === v.id) {
                            this.productsCharacteristics.push(v)
                        }
                    });
                }
            });

            this.selectedCharacteristics = []
            this.selectedModalCharacteristics = []
            this.resultCharacteristics = []
            this.isAddCharacteristics = false
            this.searchCharacteristics = null

            // axios.post(this.route('api.catalog.product.characteristic.add'), {data: this.selectedModalCharacteristics, id: this.selectedProductData.remote_id, items: this.productsCharacteristics})
            //     .then((result) => {
            //         if (result.data.is_created) {
            //             this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Дані по товару успішно оновлено', life: 3000 });
            //         }
            //         this.productsCharacteristics = result.data.characteristics
            //         this.selectedCharacteristics = []
            //         this.selectedModalCharacteristics = []
            //         this.resultCharacteristics = []
            //         this.isAddCharacteristics = false
            //         this.searchCharacteristics = null
            //     }).catch((error) => {
            //         this.selectedCharacteristics = []
            //         this.selectedModalCharacteristics = []
            //         this.resultCharacteristics = []
            //         console.log(error);
            //         window.scroll(0, 0);
            //     })
        },
        deleteCharacteristics() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані характеристики будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedCharacteristics = []
                    return
                }

                axios.post(this.route('api.catalog.product.characteristic.delete'), {data: this.selectedCharacteristics, id: this.selectedProductData.remote_id})
                    .then((result) => {
                        this.productsCharacteristics = this.productsCharacteristics.filter(item1 => !this.selectedCharacteristics.some(item2 => item2.id === item1.id));
                        // this.productsCharacteristics = result.data.characteristics
                        this.selectedCharacteristics = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedCharacteristics = []
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        deleteCatalogProductAnalog(id) {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані аналоги ринку будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                let analogs = _.cloneDeep( this.selectedProductData.service_analogs )

                axios.post(this.route('api.catalog.product.catalog_analog.delete'), {id: id})
                    .then((result) => {
                        this.selectedProductData.service_analogs = analogs.filter(item1 => item1.id !== id);
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Аналоги ринку успішно видалено', life: 3000 });
                    }).catch((error) => {
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        searchCharacteristic() {
            let result = [];

            if (this.searchCharacteristics.length > 2) {
                for (const [key, values] of Object.entries(this.characteristics)) {
                    values.forEach((v, index) => {
                        if (v.name.toLowerCase().includes(this.searchCharacteristics.toLowerCase())) {
                            result.push(v)
                        }
                    });
                }

                this.resultCharacteristics = result
            } else {
                this.resultCharacteristics = []
            }
        },
        clearSelectedCharacteristic(id) {
            let index = this.selectedModalCharacteristics.indexOf(id);
            if (index !== -1) {
                this.selectedModalCharacteristics.splice(index, 1);
            }
        },
        search() {
            if (this.searchval) {
                this.showClearInput = true;
            } else {
                this.showClearInput = false;
            }
            if (this.searchval && this.searchval.length > 2) {
                axios.post(this.route('api.vector.catalog-tree-search'), {value: this.searchval, search_type: this.search_type})
                    .then((result) => {
                        this.isShowAllGroupsRes = false;
                        this.isShowAllSubGroupsRes = false;

                        this.searchProducts = result.data.products;

                        this.overlay = true;
                        this.searchResult = true;
                    }).catch((error) => {
                        console.log(error);
                        this.searchResult = true;
                        window.scroll(0, 0);
                    })
            }
        },
        searchAccessory() {
            if (this.accessory_searchval) {
                this.accessoryShowClearInput = true;
            } else {
                this.accessoryShowClearInput = false;
            }
            if (this.accessory_searchval && this.accessory_searchval.length > 2) {
                axios.post(this.route('api.vector.catalog-tree-search'), {value: this.accessory_searchval, search_type: this.accessory_search_type})
                    .then((result) => {
                        this.isShowAllGroupsRes = false;
                        this.isShowAllSubGroupsRes = false;

                        this.accessorySearchProducts = result.data.products;

                        this.overlay = true;
                        this.accessorySearchResult = true;
                    }).catch((error) => {
                        console.log(error);
                        this.accessorySearchResult = true;
                        window.scroll(0, 0);
                    })
            }
        },
        async getTree() {
            this.loadingData = true
            let eurCurr = 0

            axios.post(this.route('api.vector.catalog-tree'), {curr: eurCurr, pdw: true})
            .then((result) => {
                this.tree = result.data;
                this.submenuTree = _.cloneDeep( this.tree );

                this.submenuTree.tree.forEach((v, index) => {
                    v.childs = this.chunk(v.childs)
                });
                this.submenuTree.brands.forEach((v, index) => {
                    v.groups = this.chunk(v.groups)
                });

                this.loadingData = false
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })

            await nextTick()
        },
        
        async getTreeByType(type, value, title = null) {

            this.isShowCatalog = false
            this.loadingData = true

            this.categoryType = type
            this.categoryCode = value
            
            axios.post(this.route('api.vector.catalog-get-product-files'), {
                id: null,
                type: type,
                value: value,
            })
            .then((result) => {
                this.items = result.data.files;
                this.selectedProductData = result.data.product;
                this.productTypes = result.data.product_types;
                this.acessoryTypes = result.data.acessory_types;
                this.path = result.data.path;
                this.product_url = result.data.product_url;
                this.types = result.data.types;
                this.is_add_new_type = result.data.is_add_new_type;
                this.is_add_new_category = result.data.is_add_new_category;
                this.decisions = result.data.decisions;
                this.loadingData = false

            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })

            await nextTick()
        },

        async getProductFiles(id) {

            this.isShowCatalog = false
            this.loadingData = true

            axios.post(this.route('api.vector.catalog-get-product-files'), {
                id: id,
            })
            .then((result) => {
                this.categoryType = null
                this.categoryCode = null
                this.items = result.data.files;
                this.selectedProductData = result.data.product;
                this.path = result.data.path;
                this.product_url = result.data.product_url;
                this.types = result.data.types;
                this.productTypes = result.data.product_types;
                this.acessoryTypes = result.data.acessory_types;
                this.is_add_new_type = result.data.is_add_new_type;
                this.is_add_new_category = result.data.is_add_new_category;
                this.productsCharacteristics = result.data.characteristics_result;
                this.characteristics = result.data.characteristics_groups;
                this.accessories = result.data.accessories
                this.analogs = result.data.analogs
                this.buy_with_products = result.data.buy_with_products
                this.decisions = result.data.decisions;
                this.resultCharacteristics = []
                this.searchResult = false
                this.loadingData = false

                this.selectedTab = 1

            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })

            await nextTick()
        },

        chunk(arr) {
            const len = Math.ceil(arr.length / 3)
            const chunks = []
            let i = 0
            const n = arr.length

            if (n) {
                while (i < n) {
                    chunks.push(arr.slice(i, i += len))
                }
            }

            return chunks
        },

        expandGroup(id) {
            this.showGroups.push(id)
        },

        clearSearch() {
            this.searchval = null;
            this.showClearInput = false;
            this.searchResult = false;
            this.accessoryShowClearInput = false;
            this.accessorySearchResult = false;
        },

        clearResult() {
            this.searchval = null;
            this.showClearInput = false;
            this.searchResult = false;
            this.path = null;
            this.selectedFiles = [];
            this.selectedTabFiles = [];
            this.selectedProductData = null;
        },

        onMenuToggle() {
            this.$parent.$data.staticMenuInactive = true
            this.$parent.$data.overlayMenuActive = false
            this.$parent.$data.mobileMenuActive = false
            // this.$parent.onMenuToggle();
        },

        addTab() {
            this.selectedFiles = []
            this.indeterminate = false
            this.selectAllCheckbox = false
            if (this.items.length <= 9) {
                this.items.push({
                    title: 'Title ' + this.items.length,
                    files: [],
                });

                this.activeTab = this.items.length - 1
            }

            this.add_new_tab_modal = true
        },

        deleteTab(index) {
            this.selectedTabFiles = []
            this.items[index].files.forEach((v, i) => {
                this.selectedTabFiles.push(v.id);
            });

            this.modal_confirm_tab = true
            this.add_new_tab_modal = false

            this.confirm_title = 'Ви хочете видалити категорію'
            if (this.selectedProductData) {
                this.confirm_text = 'Увага! Для товару ' + this.selectedProductData.name + ' буде видалена категорія ' + this.items[index].title + ' з її файлами.'
            } else {
                this.confirm_text = 'Увага! Для всіх товарів в категорії ' + this.items[index].title + ' будуть видалені файли. Будь ласка, перевірте, чи видалення не вплине на інші компоненти системи.'
            }
        },

        editTab(index) {
            this.oldTitle = this.items[index].title;
            this.edit_tab_modal = true
        },

        saveTab(activeTab) {
            this.isShowCatalog = false
            this.loadingData = true
            this.modal_confirm = false

            if (this.items[activeTab].files.length) {
                axios.post(this.route('api.vector.catalog-save-tab'), {
                    product_id: this.selectedProductData && this.selectedProductData.id ? this.selectedProductData.id : null,
                    old_title: this.oldTitle,
                    title: this.items[activeTab].title,
                    type: this.categoryType,
                    code: this.categoryCode,
                })
                .then((result) => {
                    this.oldTitle = null
                    this.edit_tab_modal = false

                    if (this.selectedProductData && this.selectedProductData.id) {
                        this.getProductFiles(this.selectedProductData.id)
                    }
                    if (this.categoryType) {
                        this.getTreeByType(this.categoryType, this.categoryCode)
                    }

                    this.selectedFiles = []
                    this.selectAllCheckbox = false
                    this.indeterminate = false
                    
                    this.loadingData = false

                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                    this.loadingData = false
                })
            } else {
                this.oldTitle = null
                this.edit_tab_modal = false
            }
        },

        addNewTab(activeTab) {
            this.newTabTitleRequired = false

            if (this.newTabTitle) {
                this.items[activeTab].title = this.newTabTitle
                this.newTabTitle = null

                this.add_new_tab_modal = false
            } else {
                this.newTabTitleRequired = true
                // if (this.is_add_new_category) {
                //     this.add_new_tab_modal = false
                // } else {
                //     this.newTabTitleRequired = true
                // }
            }
        },

        deleteNewTab(index) {
            this.add_new_tab_modal = false
            this.selectedFiles = []
            this.indeterminate = false
            this.selectAllCheckbox = false
            this.activeTab = this.items.length - 1
            this.items.splice(index, 1);
        },

        selectTab(i) {
            this.activeTab = i;
            this.selectedFiles = []
            this.indeterminate = false
            this.selectAllCheckbox = false
        },

        deleteFiles() {
            this.modal_confirm = true

            let filesNames = ''

            if (this.selectedFiles.length === 1) {
                this.confirm_title = 'Ви хочете видалити файл'
            } else {
                this.confirm_title = 'Ви хочете видалити файли'
            }

            if (this.selectedFiles.length === 1) {
                this.selectedFiles.forEach((v, i) => {
                    this.items[this.activeTab].files.forEach((file, k) => {
                        if (file.id === v) {
                            filesNames += file.name + ', '
                        }
                    })
                })

                this.confirm_text = 'Файл ' + filesNames +  ' буде видалено'
            } else {
                this.confirm_text = this.selectedFiles.length + ' файлів буде видалено'
            }
        },

        deleteFile(id) {
            if (this.selectedFiles.includes(id)) {

                let index = this.selectedFiles.indexOf(id);
                if (index !== -1) {
                    this.selectedFiles.splice(index, 1);
                }

            } else {
                this.selectedFiles.push(id);
            }

            this.modal_confirm = true

            this.confirm_title = 'Ви хочете видалити файл'
            
            let filesNames = ''

            this.items[this.activeTab].files.forEach((file, k) => {
                if (file.id === id) {
                    filesNames += file.name + ', '
                }
            })

            this.confirm_text = 'Файл ' + filesNames +  ' буде видалено'
        },

        confirm() {
            this.isShowCatalog = false
            this.loadingData = true
            this.modal_confirm = false

            axios.post(this.route('api.vector.catalog-delete-files'), {
                product_id: this.selectedProductData && this.selectedProductData.id ? this.selectedProductData.id : null,
                files: this.selectedFiles,
                type: this.categoryType,
                value: this.categoryCode,
            })
            .then((result) => {
                if (this.selectedProductData && this.selectedProductData.id) {
                    this.getProductFiles(this.selectedProductData.id)
                }
                if (this.categoryType) {
                    this.getTreeByType(this.categoryType, this.categoryCode)
                }

                this.selectedFiles = []
                this.indeterminate = false
                this.selectAllCheckbox = false
                
                this.loadingData = false

            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })
        },

        confirmTab() {
            this.isShowCatalog = false
            this.loadingData = true
            this.modal_confirm_tab = false

            axios.post(this.route('api.vector.catalog-delete-files'), {
                product_id: this.selectedProductData && this.selectedProductData.id ? this.selectedProductData.id : null,
                files: this.selectedTabFiles,
                type: this.categoryType,
                value: this.categoryCode,
            })
            .then((result) => {
                if (this.selectedProductData && this.selectedProductData.id) {
                    this.getProductFiles(this.selectedProductData.id)
                }
                if (this.categoryType) {
                    this.getTreeByType(this.categoryType, this.categoryCode)
                }

                this.selectedTabFiles = []
                
                this.loadingData = false

            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })
        },

        makeFileMain(file) {
            axios.post(this.route('api.vector.catalog-files-make-active'), {
                product_id: this.selectedProductData && this.selectedProductData.id ? this.selectedProductData.id : null,
                file: file,
            })
            .then((result) => {
                if (this.selectedProductData && this.selectedProductData.id) {
                    this.getProductFiles(this.selectedProductData.id)
                }
                if (this.categoryType) {
                    this.getTreeByType(this.categoryType, this.categoryCode)
                }

                this.selectedTabFiles = []
                
                this.loadingData = false

            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
                this.loadingData = false
            })
        },

        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('bg-drop')) {
                event.currentTarget.classList.add('bg-drop');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.remove('bg-drop');
        },

        remove(i) {
            this.filelist.splice(i, 1);
        },

        addDriveLink() {
            this.googleDriveLinkError = false;

            if (!this.google_drive_link.includes('://drive.google.com/drive/') && !this.google_drive_link.includes('://drive.google.com/file/') && !this.google_drive_link.includes('://docs.google.com')) {
                this.googleDriveLinkError = true;
            }

            if (!this.google_drive_link) {
                this.googleDriveLinkError = false;
            }
        },

        onChange() {
            if (this.$refs.file.files.length) {
                // if (this.filelist.length <= 10 && this.$refs.file.files.length <= 10 && this.filelist.length + this.$refs.file.files.length <= 10) {
                    let files = this.$refs.file.files;

                    let maxSize = 0;

                    this.filelist.forEach((value, index) => {
                        maxSize += value.size;
                    });

                    for (var i = 0; i < this.$refs.file.files.length; i++) {
                        maxSize += files[i].size;
                        
                        if ((maxSize / 1024 / 1024) <= 50) {
                            this.filelist.push(files[i]);
                        } else {
                            alert('Максимальний розмір усіх доданих файлів - 50MB');

                            return false;
                        }
                    }

                // } else {
                //     alert('Максимальна кількість файлів - 10 шт.');
                // }
            }

            // if (this.filelist.length <= 10 && this.$refs.file.files.length <= 10) {
            //     this.filelist = [...this.$refs.file.files];
            // } else {
            //     alert('Максимальна кількість файлів - 10 шт.');
            // }
        },

        upload() {
            this.uploading = true
            this.sendData = new FormData();
            this.collectFormData({
                files: this.filelist,
                product: this.selectedProductData,
                type: this.categoryType,
                code: this.categoryCode,
                tab: this.items[this.activeTab],
                google_drive_link: this.google_drive_link,
            });

            axios.post(
                this.route('api.vector.catalog-upload-files'),
                this.sendData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }
            )
            .then((result) => {
                this.docmodal = false
                this.filelist = []
                this.googleDriveLinkError = false
                this.google_drive_link = null
                this.uploading = false
                if (this.selectedProductData && this.selectedProductData.id) {
                    this.getProductFiles(this.selectedProductData.id)
                }
                if (this.categoryType) {
                    this.getTreeByType(this.categoryType, this.categoryCode)
                }
            }).catch((error) => {
                this.uploading = false
                alert(error)
                console.log(error)
                window.scroll(0, 0);
            })
        },

        copyProductUrl() {
            this.$refs.clone.focus();
            document.execCommand('copy');
        },

        rowClass (data) {
            return data.сharacteristic_lib_exists ? 'highlighted-row' : '';
        }
    }
}
</script>

<style scoped>
.content_container_row {
    display: flex;
    flex-direction: column;
}
.main_content {
    position: relative;
    display: flex;
    gap: 15px;
    width: 100%;
}
.catalog-sub-menu {
    position: relative;
    min-width: 375px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    justify-content: space-between;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
}
.sub_menu_title {
    display: flex;
    align-items: center;
}
.sub_menu_title span {
    margin-left: 8px;
}
.menu-container {
    width: 100%;
    max-width: 375px;
    height: 65vh;
    display: flex;
    top: 30px;
    left: -1px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 8px;
}
.menu {
    overflow-y: auto;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.menu::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.menu li {
    padding: 0 18px;
}
.menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.menu-item-title {
    padding: 10px 0px;
}
.menu-item-arrow {
    transform: rotate(270deg);
    width: 20px;
}
ul.menu {
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex!important;
  flex-direction: column;
}
ul.menu .groups_items {
  width: 100%;
  padding: 0;
  margin: 0;
  display: none;
  flex-direction: column;
}
ul.menu li {
    list-style: none;
}
ul.menu > li {
    height: auto;
    width: 100%;
}
.menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.group_item {
    width: 280px;
    padding: 10px;
        font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
    cursor: pointer;
}
ul.menu li a,
ul.menu .groups_items a {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 1px;
}
ul.menu>li:hover {
    background: #EFF8FF;
}
ul.menu li:hover .groups_items,
ul.menu .groups_items .group_item:hover .groups_items {
    display: flex;
    flex-direction: row;
}
ul.menu .groups_items {
    width: 860px;
    max-width: 922px;
    height: 70.5vh;
    z-index: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    margin: 0 0px 0 355px;
    top: -48px;
    box-sizing: border-box;
    padding: 30px 0px 30px 10px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 0px 0px 0px 4px;
    grid-template-columns: 1fr 1fr 1fr;
}
.group_title {
    display: block;
}
.sub_group {
    font-style: normal;
    font-weight: 400;
    font-size: 14px!important;
    line-height: 21px!important;
    color: #000000;
    display: flex;
    flex-direction: column;
}

.sub_group:hover {
    color: #356EEF!important;
}

.drop_more {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #000000;
}

.brands-title {
    color: #356EEF;
    font-weight: 500;
}

.sub_group_select {
    padding: 12px 16px;
    min-width: 150px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.new_tab_select {
    padding: 12px 16px;
    width: 100%;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.search_input_container {
    position: relative;
    z-index: 3;
    width: 100%;
}

.search_input_container svg {
    position: absolute;
    top: 15px;
    right: 15px;
}

.catalog_search_input {
    padding: 6px 16px;
    padding-right: 40px;
    min-width: 461px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
}

.catalog_search_input:focus {
    outline: none;
}

.search_input_block {
    position: relative;
}

.search_results {
    position: absolute;
    top: 48px;
    height: 500px;
    z-index: 1;
    overflow: auto;
    background: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #C8E4FF;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.search_results .main_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
    padding: 12px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .show_all_link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
    padding: 0px 16px;
}

.search_results .products {
    width: 100%;
}

.content_row {
    display: flex;
    width: 100%;
    gap: 15px;
}

.result_content {
    border-radius: 4px;
    border: 1px solid #C8E4FF;
    width: 100%;
    margin-top: 16px;
    padding: 16px;
}

.result_content_main_title {
    font-style: normal;
    font-weight: 700;
    font-size: 25px;
    line-height: 30px;
    color: #212529;
}

.result_content_title {
    color: #356DEF;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.16px;
    margin-bottom: 20px;
}

.top_panel {
    display: flex;
    gap: 10px;
    align-items: center;
}
.tabs {
    display: flex;
    align-items: center;
    overflow: auto;
}
.content_tab {
    border-bottom: 2px solid var(--border-border-subtle-01, #C6C6C6);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 11px 16px;
    color: var(--text-text-secondary, var(--text-text-secondary, #525252));
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16px;
}
.content_tab.active {
    border-bottom: 2px solid var(--border-border-interactive, #0F62FE);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
}
.content_tab-item {
    color: var(--text-text-primary, var(--text-text-primary, #161616));
    font-weight: 600;
}
.tab_content_item_form_input_label {
    display: block;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 8px;
}
.input_row {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
}
.form_input {
    width: 100%;
    height: 30px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 10px;
    padding-right: 30px;
}
.new_tab_input {
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 10px;
    padding-right: 30px;
}
.input_row a {
    position: absolute;
    right: 10px;
    top: 7px;
    cursor: pointer;
}
.tab_content_item_form_input {
    width: 100%;
}
.row_inputs {
    display: flex;
    gap: 16px;
    margin-top: 12px;
    margin-bottom: 12px;
}
.files_table_container {
    margin-top: 20px;
}
.files_table {
    width: 100%;
}
.files_table tr td{
    text-align: center;
}
.text_center {
    text-align: center;
}
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.delete_file_btn {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30);
    display: flex;
    width: 133px;
    height: 40px;
    padding: 12px 30px;
    justify-content: center;
    align-items: center;
}

.files_btns_row {
    display: flex;
    gap: 16px;
    width: 100%;
}
.confirm_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 100%;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
}
.cancel_btn {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30);
    display: flex;
    width: 100%;
    height: 40px;
    padding: 12px 30px;
    justify-content: center;
    align-items: center;
}

.modal_header {
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.modal_text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #1C1C1C;
    margin: 0px;
}

.docmodal .modal_header_title {
    margin: 0px;
}
.docmodal .modal_header {
    border-bottom: none;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
}

.modal_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #212529;
}
.modal_text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
.modal_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #356EEF;
}
.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}
.modal {
    display: block;
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}
.docmodal {
    width: 504px;
}

.modal_btn {
    height: 46px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #FFFFFF;
    background: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 16px;
    cursor: pointer;
}

.modal_btn_link {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #1C1C1C;
    cursor: pointer;
}
.close_btn {
    position: absolute;
    right: 20px;
    cursor: pointer;
}
.doc_modal_form_container {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.doc_modal_form_content {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border: 2px dashed #CED4DA;
    border-radius: 24px;
    width: 100%;
    height: 323px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.doc_modal_form_content.active {
    flex-direction: revert;
    gap: 16px;
}

.doc_modal_form_content.active .file_modal_container {
    text-align: start;
    justify-content: start;
    align-items: start;
}

.file_modal_container {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}
#close_docmodal {
    position: absolute;
    right: 0;
    top: 5px;
    cursor: pointer;
}
.text_secondary{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #8E8F96;
    padding: 0px 20px;
}
.added_files{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.05em;
    color: #919299;
}

.added_files_header {
    width: 400px;
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    margin-bottom: 8px;
}

.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    width: 400px;
    overflow: auto;
    max-height: 135px;
}

.docs_filelist {
    width: 100%;
    max-height: 345px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}

.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}

.modal_input_container {
    display: flex;
    width: 100%;
    max-width: 400px;
    position: relative;
}

.modal_input_container .link_ico {
    position: absolute;
    left: 20px;
    top: 16px;
}
.modal_input_container .close_ico {
    position: absolute;
    right: 20px;
    top: 16px;
    cursor: pointer;
}

.google_drive_link {
    width: 100%;
    display: block;
    max-width: 400px;
    height: 44px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    padding-left: 50px;
    padding-right: 40px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
}
.description_modal .modal_header {
    border-bottom: none;
}
.add_new_tab_modal .modal_confirm_content {
    margin-bottom: 10px;
}
.modal_confirm_content {
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28.8px;
    margin-bottom: 30px;
}
.modal_confirm_content.danger {
    color: red;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}

input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.zindex0 {
    z-index: 0!important;
}

.result_content_row {
    display: flex;
    justify-content: space-between;
    align-content: center;
}
.file_count {
    margin: 0;
    padding: 0;
    margin-top: 10px;
    color: #525252;
}
.caontent_container {
    border: 1px solid #C8E4FF;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 16px;
}
.main_tabs {
    gap: 8px;
}
.tab {
    border-top: 1px solid #C8E4FF;
    border-left: 1px solid #C8E4FF;
    border-right: 1px solid #C8E4FF;
    padding: 8px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    color: #161616;
    font-weight: 500;
    cursor: pointer;
    min-width: max-content;
}
.tab.active {
    background-color: #C8E4FF;
}
.product_description_text {
    width: 100%;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.modal_main_content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.select_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.select_group p {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
}
.modal_group_item label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
}
.nested_list {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.selected_group_items {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
#characteristics-table th {
    background: #fff !important;
}
.price_input {
    height: 30px!important;
}
.border_error {
    border-color: red!important;
}
.search_result {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.close_results {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 13px;
    cursor: pointer;
    min-width: 170px;
}
.results_badge {
    background: #EFF8FF;
    border: 1px solid #FFFFFF;
    border-radius: 30px;
    padding: 4px 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    /* max-width: 600px; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
}

.results_badge svg {
    cursor: pointer;
}
.editor_textarea {
    width: 100%;
}
.flex_list {
    display: flex;
    flex-direction: column;
}
</style>
